<template>
  <div
    ref="cardRoot"
    id="cardRoot"
    :data-target="content.card_id ? content.card_id : content.id"
    :data-hash_id="content.hash_id"
    :data-cid="cid"
    :data-route="route"
    :data-section="section"
    data-target_type="card"
    @mousedown="startDrag"
    @dragstart="onDragStart"
    @dragend="onDragEnd"
    @mouseenter="mouseEnter"
    :style="
      'position:relative;border-radius:' +
      mergedLayout.appearance.borderRadius +
      'px;overflow:hidden'
    "
    :class="[
      'shadow-' +
        mergedLayout.appearance.shadow +
        '-card ' +
        (mergedLayout.appearance.bordered
          ? ' border-' + mergedLayout.appearance.bgColor
          : ''),
      'bg-white',
    ]"
  >
    <q-layout
      ref="layout"
      class=""
      view="hHh lpR fFf"
      container
      :style="`height:${cardHeight};width:${cardWidth};overflow:hidden`"
    >
      <DCardToolbar
        v-if="mergedLayout.appearance.showsHeader"
        :component="'QHeader'"
        :textColor="mergedLayout.appearance.textColor"
        :bgColor="mergedLayout.appearance.bgColor"
        :divider="mergedLayout.appearance.divider"
        @resize="(size) => (this.headerToolBarHeight = size)"
        ref="headerToolBar"
      >
        <!-- <DCardToolbarButton
          v-if="mergedLayout.menu.position === 'left'"
          style="width: 35px"
          @click="menuClicked"
          icon="menu"
          :invisible="
            !mergedLayout.appearance.showsMenu || content.pages.length === 1
          "
        >
        </DCardToolbarButton> -->
        <div class="full-width" v-if="travelAgentBusinessBanner">
          <DCardBusinessBanner
            :businessBanner="travelAgentBusinessBanner"
            ref="travelToolBar"
            @openBusinessCard="$emit('openBusinessCard')"
            @loadAllContent="travelAgentBannerLoaded = true"
          />
        </div>

        <DCardToolbarBrand
          :logo="mergedLayout.appearance.brand.logo"
          :title="mergedLayout.appearance.brand.title"
          :invisible="!mergedLayout.appearance.showsBrand"
        />

        <div style="width: 35px">
          <q-icon
            v-if="showInfoModal"
            key="info"
            size="md"
            name="info"
            @click="showModalInfo = !showModalInfo"
          />
        </div>
        <!-- <DCardToolbarButton
          v-if="mergedLayout.menu.position === 'right'"
          style="width: 35px"
          @click="menuClicked"
          icon="menu"
          :invisible="
            !mergedLayout.appearance.showsMenu || content.pages.length === 1
          "
        >
        </DCardToolbarButton> -->
      </DCardToolbar>

      <DCardMenu
        @click="(i) => (activePage = i)"
        :pages="content.pages"
        v-model="showMenu"
        :width="cardWidth"
        :position="mergedLayout.menu.position"
        :textColor="mergedLayout.menu.textColor"
        :bgColor="mergedLayout.menu.bgColor"
        :headerTextColor="mergedLayout.menu.headerTextColor"
        :headerBgColor="mergedLayout.menu.headerBgColor"
        :headerTitle="mergedLayout.menu.headerTitle"
        :darkSeparator="mergedLayout.menu.darkSeparator"
        :showPageNumber="mergedLayout.menu.showPageNumber"
      />

      <q-page-container>
        <q-page>
          <DCardContent
            @invokeComponent="invokeComponent"
            v-model="activePage"
            :layout="mergedLayout"
            :content="content"
            :parentMetas="content.parentMetas"
            :scrollerHeight="availableContentHeight"
            :behavior="behavior"
            @event="eventHandler"
            :noScrolling="noScrolling"
          ></DCardContent>
        </q-page>
      </q-page-container>

      <DCardToolbar
        v-if="mergedLayout.appearance.showsFooter && content.pages.length > 1"
        :component="'QFooter'"
        :textColor="mergedLayout.appearance.textColor"
        :bgColor="mergedLayout.appearance.bgColor"
        :divider="mergedLayout.appearance.divider"
        ref="footerToolBar"
        @resize="(size) => (this.footerToolBarHeight = size)"
      >
        <DCardToolbarNavigation
          :class="
            'col ' + (mergedLayout.appearance.showsNavigation || ' invisible')
          "
          v-model="activePage"
          :length="content.pages.length"
        />
      </DCardToolbar>
    </q-layout>
    <DScrollArea
      ref="info"
      class="hidden"
      :width="cardWidth"
      :height="cardHeight"
    >
      <DCardInfo
        :reset="!showModalInfo"
        :info="content.info"
        :partenMetas="content.parentMetas"
      />
    </DScrollArea>
    <div
      v-if="false"
      v-show="content.info !== undefined && behavior === 'agent'"
      style="position: absolute; right: 4px; top: 4px"
    >
      <q-btn
        @click="toggleInfo"
        :icon="showingInfo ? 'flip' : 'info'"
        size="md"
        color="primary"
        flat
        round
        unelevated
      />
    </div>
    <div v-if="canNavigate" class="d-navigable-card" />
    <div @click.stop="() => {}">
      <DCardActionOverlay
        @trackingEvent="trackingEvent"
        :showsEnterSection="canNavigate"
        :overlayList="content.overlay"
        :overlayTitle="content.overlayTitle"
        :loading="loading"
        :hashId="content.hash_id"
        :apiBaseUrl="apiBaseUrl"
        :cid="content.client_id ? content.client_id : content.cid"
        @enterSection="enterSection"
        @preview="$emit('preview', content)"
        @mouseLeave="mouseLeaveOverlay"
        @keepOverlay="toggleOverlayKeeper"
        v-if="canShowOverlay"
      />
    </div>
    <DComponentOverlay
      class="full-width bg-black"
      :height="cardHeight"
      :behavior="behavior"
      :parentMetas="content.parentMetas"
      @hide="hideOverlayAndResetDraggable"
      :cid="content.client_id ? content.client_id : content.cid"
      ref="componentOverlay"
    />
    <!-- CHROME DND GHOST IMAGE PATCH -->
    <div
      ref="overlay"
      :style="
        'visibility:hidden;top:0;left:0;position:absolute;width:' +
        mergedLayout.appearance.width +
        'px;height:' +
        mergedLayout.appearance.height +
        'px'
      "
    ></div>
    <DCardModalInfo :show="showModalInfo">
      <DCardInfo
        :info="content.info"
        :sequence="true"
        :partenMetas="content.parentMetas"
      />
    </DCardModalInfo>
  </div>
</template>

<script>
import { debounce, extend, uid } from "quasar";
import defaultLayout from "./d-card-default-layout";
import mixin from "./d-card-mixins";
import DCardToolbar from "./DCardToolbar.vue";
import DCardToolbarBrand from "./DCardToolbarBrand.vue";
import DCardToolbarNavigation from "./DCardToolbarNavigation.vue";
import DCardToolbarButton from "./DCardToolbarButton.vue";
import DCardMenu from "./DCardMenu.vue";
import DCardContent from "./DCardContent.vue";
import DCardInfo from "../DCardInfo/DCardInfo";
import DScrollArea from "./DScrollArea.vue";
import DCardActionOverlay from "./DCardActionOverlay.vue";
import DComponentOverlay from "./components/DComponentOverlay.vue";
import DCardModalInfo from "./DCardModalInfo.vue";
import { routeAndSectionMixin } from "../../mixins/routeAndSectionMixin";
import DCardBusinessBanner from "./DCardBusinessBanner.vue";

export default {
  name: "DCard",
  components: {
    DCardToolbar,
    DCardToolbarBrand,
    DCardToolbarButton,
    DCardToolbarNavigation,
    DCardMenu,
    DCardContent,
    DCardInfo,
    DScrollArea,
    DCardActionOverlay,
    DComponentOverlay,
    DCardModalInfo,
    DCardBusinessBanner,
  },
  mixins: [mixin, routeAndSectionMixin],
  props: {
    content: {
      type: Object,
      required: true,
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    layout: {
      type: Object,
      default: () => new Object(),
    },
    draggable: {
      type: Boolean,
      default: true,
    },
    behavior: {
      type: String,
      default: "agent",
    },
    showsActionOverlay: {
      type: Boolean,
      default: true,
    },
    allowNavigation: {
      type: Boolean,
      default: true,
    },
    noScrolling: {
      type: Boolean,
      default: false,
    },
    calcSize: {
      type: Boolean,
      default: false,
    },
    travelAgentBusinessBanner: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    apiBaseUrl: {
      type: Object,
      required: false,
      default: () => {},
    },
    pluginPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lshowMenu: false,
      lactivePage: 0,
      showingInfo: false,
      showingActionOverlay: false,
      canHideOverlay: true,
      showingContentOverlay: false,
      contentOverlayData: {},
      showModalInfo: false,
      headerToolBarHeight: 56,
      footerToolBarHeight: 50,
      availableContentHeight: 0,
      travelAgentBannerLoaded: true,
    };
  },
  computed: {
    canNavigate: {
      get() {
        return (
          this.behavior === "agent" &&
          this.allowNavigation &&
          this.content?.meta?.navigation !== undefined
        );
      },
    },
    // this will show to costumer a modal windows
    showInfoModal: {
      get() {
        if (this.mergedLayout.appearance?.showInfoModal) {
          return this.mergedLayout.appearance.showInfoModal;
        }
        return false;
      },
    },
    showMenu: {
      get() {
        if (this.behavior === "agent") {
          return this.lshowMenu;
        } else {
          return this.$cardStore.get("showMenu");
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lshowMenu = val;
        } else {
          this.$cardStore.set("showMenu", val);
        }
      },
    },
    activePage: {
      get() {
        if (this.behavior === "agent") {
          return this.lactivePage;
        } else {
          return this.$cardStore.get("activePage");
        }
      },
      set(val) {
        if (this.behavior === "agent") {
          this.lactivePage = val;
        } else {
          this.$cardStore.set("activePage", val);
        }
      },
    },
    mergedLayout: {
      get() {
        const x = extend(
          true,
          {},
          defaultLayout,
          JSON.parse(JSON.stringify(this.layout)),
          this.content.layout
            ? JSON.parse(JSON.stringify(this.content.layout))
            : {}
        );
        if (this.behavior === "consumer") {
          x.appearance.showsPreview = false;
        }
        return x;
      },
    },
    cardHeight: {
      get() {
        const height =
          this.behavior === "agent"
            ? this.mergedLayout.appearance.height
            : window.innerHeight;
        if (typeof height === "number") {
          return `${height}px`;
        } else {
          return height;
        }
      },
    },
    cardWidth: {
      get() {
        const width =
          this.behavior === "agent"
            ? this.mergedLayout.appearance.width
            : window.innerWidth;
        if (typeof width === "number") {
          return `${width}px`;
        } else {
          return width;
        }
      },
    },
    cid: {
      get() {
        if (this.content.cid) {
          return this.content.cid;
        }

        return this.content.client_id ?? "";
      },
    },
    canShowOverlay: {
      get() {
        if (this.behavior !== "agent") {
          return false;
        }

        if (!this.canHideOverlay) {
          return true;
        }

        return this.showingActionOverlay;
      },
    },
  },
  created() {
    if (this.behavior === "consumer") {
      this.$cardStore.setDefaultState(this.content);
      this.$cardStore.subscribe("statelistener", (mutation, stateCopy) => {
        console.log("mutation", mutation);
        console.log("emit", stateCopy);
        this.$emit("stateChanged", stateCopy);
      });
    }
    this.toggleOverlayKeeper = debounce(this.toggleOverlayKeeper, 100);
  },
  mounted() {
    if (this.travelAgentBusinessBanner) {
      this.travelAgentBannerLoaded = false;
      return;
    }
    this.getHeaderFooterSizes();
  },
  methods: {
    getHeaderFooterSizes() {
      this.headerToolBarHeight = this.$refs?.headerToolBar?.$el.scrollHeight;
      this.footerToolBarHeight = this.$refs?.footerToolBar?.$el.scrollHeight;
      this.setAvailableContentHeight();
    },
    setAvailableContentHeight() {
      const cardHeight =
        typeof this.cardHeight === "string"
          ? this.cardHeight.replace("px", "")
          : this.cardHeight;
      let availableContentHeight = cardHeight;
      if (this.mergedLayout.appearance.showsHeader)
        availableContentHeight -= this.headerToolBarHeight;
      if (
        this.mergedLayout.appearance.showsFooter &&
        this.content.pages.length > 1
      ) {
        availableContentHeight -= this.footerToolBarHeight;
      }
      if (this.mergedLayout.appearance.showsContentTitle) {
        availableContentHeight -= this.mergedLayout.contentTitle.height;
      }
      if (this.mergedLayout.appearance.divider) availableContentHeight -= 2;
      this.availableContentHeight = availableContentHeight;
    },
    hideOverlayComponent() {
      this.$refs.componentOverlay.hide();
      this.startDrag();
    },
    closeOverlayContent() {
      this.showingContentOverlay = false;
      this.contentOverlayData = {};
    },
    eventHandler(ev) {
      const handler = ev.data.handler.bind(this);
      handler(ev.data);
    },
    cardPreview() {
      this.$emit("cardPreview", this.content.id);
    },
    startDrag() {
      if (!this.draggable || this.showingInfo || this.showingComponentOverlay) {
        this.$refs.cardRoot.setAttribute("draggable", false);
        return;
      }
      this.$refs.cardRoot.setAttribute("draggable", true);
    },
    onDragStart(e) {
      this.showingActionOverlay = false;
      this.$refs.cardRoot.style.opacity = 0.2;
      // CHROME DND GHOST IMAGE PATCH
      if (this.$q.platform.is.chrome) {
        e.dataTransfer.setDragImage(this.$refs.overlay, e.offsetX, e.offsetY);
      }
      e.dataTransfer.dropEffect = "move";
      this.$coreInterface.cardDragStart(this.pluginPreview);
    },
    onDragEnd(e) {
      //this.showingActionOverlay = false;
      this.$refs.cardRoot.style.opacity = 1;
      try {
        this.$refs.cardRoot.setAttribute("draggable", "false");
        const position = { x: e.clientX, y: e.clientY };
        this.$coreInterface.cardDragEnd(position, this.content, this.pluginPreview);
      } catch (error) {
        //console.log('error', error)
      }
    },
    menuClicked() {
      this.showMenu = !this.showMenu;
    },
    setState(state) {
      console.log("receive", state);
      this.$cardStore.setState(state);
    },
    toggleInfo() {
      const front = this.$refs.layout.$el;
      const back = this.$refs.info.$el;
      if (back.classList.contains("hidden")) {
        // if front is on screen
        this.showingInfo = true;
        front.classList.add("hidden");
        //front.classList.remove("animate__animated", "animate__flipOutY");
        back.classList.remove("hidden");
        back.classList.add("animate__animated", "animate__flipInY");
      } else {
        this.showingInfo = false;
        back.classList.add("hidden");
        back.classList.remove("animate__animated", "animate__flipInY");
        front.classList.remove("hidden");
        front.classList.add("animate__animated", "animate__flipInY");
      }
    },
    click() {
      this.$emit("click", this.content);
    },
    mouseEnter(e) {
      if (this.showsActionOverlay) {
        this.showingActionOverlay = true;
        this.$emit("cardFocus", this.content.id);
      }
    },
    mouseLeaveOverlay(e) {
      this.showingActionOverlay = false;
    },
    hideOverlay() {
      this.showingActionOverlay = false;
    },
    toggleOverlayKeeper(data) {
      this.canHideOverlay = !data;
    },
    hideOverlayAndResetDraggable() {
      this.showingComponentOverlay = false;
    },
    enterSection() {
      this.$emit("enterSection");
    },
    invokeComponent(params) {
      if (!this.content?.components) return;
      const data = this.content.components.find((item) => {
        return item.id === params.id && item.component === params.component;
      });
      const dataCopy = { ...data };
      if (params?.state) {
        dataCopy.state = params.state;
      }
      if (dataCopy) {
        this.showingComponentOverlay = true;
        this.$refs.componentOverlay.show(dataCopy);
      }
    },
    trackingEvent(data) {
      this.$emit("trackingEvent", data);
    },
  },
  watch: {
    calcSize(value) {
      if (value) {
        this.getHeaderFooterSizes();
      }
    },
    travelAgentBannerLoaded(val) {
      if (val) {
        this.getHeaderFooterSizes();
      }
    },
    headerToolBarHeight() {
      this.setAvailableContentHeight();
    },
    footerToolBarHeight() {
      this.setAvailableContentHeight();
    },
  },
};
</script>

<style lang="sass">
@import url('../borders.sass')
</style>
<style lang="scss" scoped>
@import url("./d-card.scss");
</style>
<style>
div.clickEffect {
  position: fixed;
  box-sizing: border-box;
  border-style: solid;
  border-color: #ff0000;
  border-radius: 50%;
  animation: clickEffect 0.4s ease-out;
  z-index: 10000;
}
:root {
  --animate-duration: 300ms;
}
@keyframes clickEffect {
  0% {
    opacity: 1;
    width: 0.5em;
    height: 0.5em;
    margin: -0.25em;
    border-width: 0.5em;
  }
  100% {
    opacity: 0.2;
    width: 15em;
    height: 15em;
    margin: -7.5em;
    border-width: 0.03em;
  }
}
.animate__animated {
  -webkit-animation-duration: 0.4s;
  animation-duration: 0.4s;
  -webkit-animation-duration: 0.4s;
  animation-duration: 0.4s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@keyframes flipInY {
  from {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -90deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }

  to {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }
}
.animate__flipInY {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipInY;
  animation-name: flipInY;
}

@keyframes flipOutY {
  from {
    -webkit-transform: perspective(400px);
    transform: perspective(400px);
  }

  to {
    -webkit-transform: perspective(400px) rotate3d(0, 1, 0, -90deg);
    transform: perspective(400px) rotate3d(0, 1, 0, -90deg);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
    opacity: 0;
  }
}
.animate__flipOutY {
  -webkit-backface-visibility: visible !important;
  backface-visibility: visible !important;
  -webkit-animation-name: flipOutY;
  animation-name: flipOutY;
}
</style>
